// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"SideBar_sideBar__2j9J3"};